import { useState } from "react";
import { useRule } from "../CreateRuleNew/RuleReducer";
import Button2 from "../../../Button/Button2";
import { Calendar } from "primereact/calendar";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import classes from "./RuleWizard.module.css";
import Button3 from "../../../Button/Button3";

const Days = ["Mon", "Tues", "Wed", "Thur", "Fri", "Sat", "Sun"];

export const GATEWAY_EVENTS = [
    "Correct pin entered",
    "Padlock opened",
    "Padlock closed",
    "Invalid pin attempted"
];

const WizardStepTrigger = ({ pins, firmware, smartLocks, onNext, onBack }) => {
    const { state, dispatch } = useRule();
    const [triggerTime, setTriggerTime] = useState(null);
    const [timeDescriptionVisible, setTimeDescriptionVisible] = useState(false)
    const [gatewayDescriptionVisible, setGatewayDescriptionVisible] = useState(false)
    const gatewayConditions = state.conditions.filter(c => c.condition_type === "GATEWAY_EVENT");
    const [timePhase, setTimePhase] = useState(state.triggerTime ? "SWITCH" : "TIME") // "TIME" | "SWITCH"

    const parts = (firmware || "0.0.0").split(".");
    const [maj, min, rev] = parts.map(Number);
    const supportsOutputPulse = maj > 2 || (maj === 2 && (min > 1 || (min === 1 && rev >= 1)));
    const supportsInputPulse = maj >= 2 || (maj === 1 && min >= 9);

    const handleGeofence = (direction) => {
        dispatch({ type: "SET_IS_GEOFENCE", payload: true });
        dispatch({ type: "SET_IS_TIME_TRIGGER", payload: false });
        dispatch({ type: "SET_GEOFENCE_DIRECTION", payload: direction === "enter" ? "Enter" : "Exit" });
        if (pins.length > 0) {
            dispatch({ type: "SET_DEVICE_UUID", payload: pins[0].DeviceUUID });
        }
        dispatch({ type: "SET_ADV_RULE_ACTION", payload: [] });
        dispatch({ type: "SET_SELECTED_PINS_TO_AFFECT", payload: [] });
        onNext();
    };


    const handleTime = (value) => {
        setTriggerTime(value);
        if (!value) {
            dispatch({ type: "SET_IS_TIME_TRIGGER", payload: false });
            dispatch({ type: "SET_TRIGGER_TIME", payload: null });
            return;
        }
        dispatch({ type: "SET_IS_GEOFENCE", payload: false });
        dispatch({ type: "SET_IS_TIME_TRIGGER", payload: true });
        dispatch({
            type: "SET_TRIGGER_TIME",
            payload: `${String(value.getHours()).padStart(2, "0")}:${String(value.getMinutes()).padStart(2, "0")}`,
        });
        dispatch({ type: "SET_TRIGGER_TIMEZONE", payload: Intl.DateTimeFormat().resolvedOptions().timeZone });
        if (pins.length > 0) {
            dispatch({ type: "SET_DEVICE_UUID", payload: pins[0].DeviceUUID });
        }
    };

    const toggleDay = (dayIndex) => {
        const next = state.trigger_days_of_week.includes(dayIndex)
            ? state.trigger_days_of_week.filter(d => d !== dayIndex)
            : [...state.trigger_days_of_week, dayIndex];
        dispatch({ type: "SET_TRIGGER_DAYS_OF_WEEK", payload: next });
    };

    const convertSelectionToSubType = (selection) => {
        switch (selection) {
            case 0: 
                return "unlocked"
            case 1: 
                return "opened"
            case 2: 
                return "locked"
            case 3: 
                return "invalidPIN"
            default:
                return ""
        }
    }

    const availableGatewayEvents = GATEWAY_EVENTS
        .map((label, idx) => ({ label, idx }))
        .filter(({ idx }) => !gatewayConditions.some(c => c.gateway_event_subtype === convertSelectionToSubType(idx)));

    const handleAddGatewayEvent = (trigger) => {
        const condition = {
            condition_type: "GATEWAY_EVENT",
            pin_name: GATEWAY_EVENTS[trigger],
            gateway_event_family: "lockEvent",
            gateway_event_subtype: convertSelectionToSubType(trigger),
            time_condition: "ANYTIME",
            days_of_week: ["0", "1", "2", "3", "4", "5", "6"],
            is_absence_condition: false,
        };
        dispatch({ type: "SET_ADV_RULE_CONDITION", payload: [condition] });
        if (pins.length > 0) {
            dispatch({ type: "SET_DEVICE_UUID", payload: pins[0].DeviceUUID });
        }
        dispatch({ type: "SET_ADV_RULE_ACTION", payload: [] });
        dispatch({ type: "SET_SELECTED_PINS_TO_AFFECT", payload: [] });
    }

    const isInputPin = (pin) => pin.type === "INPUT" || pin.type === "VIRTUAL_INPUT";

    const renderPinPicker = (pinList, onPick) => {
        const outputPins = pinList.filter(pin => !isInputPin(pin));
        const inputPins = pinList.filter(isInputPin);
        return (
            <>
                {outputPins.length > 0 && (
                    <div style={{ marginBottom: inputPins.length > 0 ? "14px" : 0 }}>
                        <p style={{ color: "#9e9e9e", fontSize: "11px", fontWeight: 700, textTransform: "uppercase", margin: "0 0 6px 0" }}>Outputs</p>
                        <div className={classes.pinGrid}>
                            {outputPins.map((pin, i) => (
                                <Button3
                                    key={i}
                                    style={{ minWidth: "150px", minHeight: "44px" }}
                                    onClick={() => onPick(pin)}
                                >
                                    {pin.pinName}
                                </Button3>
                            ))}
                        </div>
                    </div>
                )}
                {inputPins.length > 0 && (
                    <div>
                        <p style={{ color: "#9e9e9e", fontSize: "11px", fontWeight: 700, textTransform: "uppercase", margin: "0 0 6px 0" }}>Inputs</p>
                        <div className={classes.pinGrid}>
                            {inputPins.map((pin, i) => (
                                <Button3
                                    key={i}
                                    style={{ minWidth: "150px", minHeight: "44px" }}
                                    onClick={() => onPick(pin)}
                                >
                                    {pin.pinName}
                                </Button3>
                            ))}
                        </div>
                    </div>
                )}
            </>
        );
    };

    const handlePin = (pin) => {
        console.log(pin);
        const isLock = smartLocks.some(l => parseInt(l.outputPin) === pin.Pin);
        dispatch({ type: "SET_IS_GEOFENCE", payload: false });
        dispatch({ type: "SET_SELECTED_PIN", payload: pin });
        dispatch({ type: "SET_PIN_NUMBER", payload: pin.Pin });
        dispatch({ type: "SET_IS_LOCK", payload: isLock });
        dispatch({ type: "SET_IS_REGULAR_OUTPUT", payload: smartLocks.every(l => parseInt(l.outputPin) !== pin.Pin) });
        dispatch({ type: "SET_IS_INPUT", payload: pin.type === "INPUT" || pin.type === "VIRTUAL_INPUT" });
        dispatch({ type: "SET_PIN_STATUS_ON", payload: pin.pinStatusOn });
        dispatch({ type: "SET_PIN_STATUS_OFF", payload: pin.pinStatusOff });
        dispatch({ type: "SET_DEVICE_UUID", payload: pin.DeviceUUID });
        dispatch({ type: "SET_SUPPORTS_OUTPUT_PULSE", payload: supportsOutputPulse });
        dispatch({ type: "SET_SUPPORTS_INPUT_PULSE", payload: supportsInputPulse });
        dispatch({ type: "SET_SITE_TYPE", payload: pin.DeviceType });
        dispatch({ type: "SET_PIN_NAME", payload: pin.pinName });
        dispatch({ type: "SET_IS_PULSE", payload: pin.type === "PULSE" || pin.type === "VIRTUAL_PULSE" });

        const condition = {
            condition_type: "STATE_CHECK",
            pin: pin.Pin,
            pin_name: pin.pinName,
            pin_state: pin.type === "PULSE" || pin.type === "VIRTUAL_PULSE" ? "PULSE" : pin.pin_state,
            trigger_method: pin.type === "PULSE" || pin.type === "VIRTUAL_PULSE" ? "PULSE" : "LATCH",
            trigger_method_type: "ANY",
            time_condition: "ANYTIME",
            days_of_week: ["0", "1", "2", "3", "4", "5", "6"],
            is_absence_condition: false,
            is_deadline_condition: false,
            is_lock: isLock,
            pin_status_on: pin.pinStatusOn,
            pin_status_off: pin.pinStatusOff,
        };

        dispatch({ type: "SET_ADV_RULE_CONDITION", payload: [condition] });
        dispatch({ type: "SET_CONDITION_EDIT_INDEX", payload: 0 });
        dispatch({ type: "SET_ADV_RULE_ACTION", payload: [] });
        dispatch({ type: "SET_SELECTED_PINS_TO_AFFECT", payload: [] });
        dispatch({ type: "SET_INPUT_TYPE", payload: -1 });
        dispatch({ type: "SET_INPUT_TYPE_COPY", payload: -1 });
        onNext();
    };

    return (
        <>
            <div className={classes.contentHeader}>
                <h2 className={classes.contentTitle}>
                    {state.triggerType === "GATEWAY" ? "Which gateway event triggers this rule?"
                        : state.triggerType === "TIME" ? (timePhase === "TIME" ? "What time triggers this rule?" : "Which switch should this check?")
                        : "What triggers this rule?"}
                </h2>
            </div>
            <div style={{ flex: 1, overflowY: "auto", display: "flex", flexDirection: "column", gap: "20px" }}>
                {state.triggerType === "GATEWAY" && (
                    <div>
                        {gatewayConditions.length > 0 ? (
                            <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                                <p style={{ color: "#9e9e9e", fontSize: "11px", fontWeight: 700, textTransform: "uppercase", margin: "0 0 4px 0" }}>
                                    Selected event
                                </p>
                                <div className={classes.conditionChips}>
                                    {gatewayConditions.map((cond, i) => (
                                        <span key={i} className={classes.chip}>{cond.pin_name}</span>
                                    ))}
                                </div>
                            </div>
                        ) : (
                            <>
                                <p className={classes.contentSubtitle}>{"Choose a gateway event to trigger the rule"}</p>
                                {availableGatewayEvents.map(({ label, idx }) => (
                                    <Button3
                                        key={label}
                                        style={{ minWidth: "50px", minHeight: "30px", fontSize: "12px", marginTop: "8px", marginRight: "8px" }}
                                        onClick={() => handleAddGatewayEvent(idx)}
                                    >
                                        {label}
                                    </Button3>
                                ))}
                                <p style={{ color: "#4f7bff", marginTop: 5, fontSize: "13px", fontWeight: 400, cursor:"pointer"}} onClick={() => setGatewayDescriptionVisible(true)}>What's this?</p>
                            </>
                        )}
                    </div>
                )}

                {state.triggerType === "SWITCH" && (
                    <div>
                        <p className={classes.contentSubtitle}>Choose an output or input to trigger the rule</p>
                        <br/>
                        {renderPinPicker(pins, handlePin)}
                    </div>
                )}

                {state.triggerType === "TIME" && timePhase === "TIME" && (
                    <div>
                        <p className={classes.contentSubtitle}>Choose a time for this rule to trigger</p>
                        <br/>
                        <div className={classes.pinGrid}>
                            <Calendar
                                placeholder={"Time"}
                                value={triggerTime}
                                onChange={(e) => handleTime(e.value)}
                                timeOnly
                                appendTo="self"
                            />
                        </div>

                        <p style={{ color: "#6e6e6e", fontSize: "13px", margin: "14px 0 6px 0" }}>Active on:</p>
                        <div style={{ display: "flex", flexWrap: "wrap", gap: "5px" }}>
                            {["1", "2", "3", "4", "5", "6", "0"].map((d, i) => (
                                <Button3
                                    key={i}
                                    style={{
                                        minWidth: "50px", minHeight: "30px", fontSize: "12px",
                                        backgroundColor: state.trigger_days_of_week.includes(d) ? "var(--Primary-Color)" : undefined,
                                        color: state.trigger_days_of_week.includes(d) ? "white" : undefined,
                                    }}
                                    onClick={() => toggleDay(d)}
                                >
                                    {Days[i]}
                                </Button3>
                            ))}
                        </div>
                        <p style={{ color: "#4f7bff", marginTop: 10, fontSize: "13px", fontWeight: 400, cursor:"pointer"}} onClick={() => setTimeDescriptionVisible(true)}>What's this?</p>
                    </div>
                )}

                {state.triggerType === "TIME" && timePhase === "SWITCH" && (
                    <div>
                        <p className={classes.contentSubtitle}>Which switch should be checked when the time elapses?</p>
                        <br/>
                        {renderPinPicker(pins, handlePin)}
                    </div>
                )}
            </div>

            <div className={classes.navRow}>
                <Button
                    label="Back"
                    icon="pi pi-arrow-left"
                    severity="secondary"
                    outlined
                    onClick={() => {
                        if (state.triggerType === "TIME" && timePhase === "SWITCH") {
                            setTimePhase("TIME");
                        } else {
                            onBack();
                        }
                    }}
                />
                {state.triggerType === "GATEWAY" ? (
                    <Button
                        label="Next"
                        icon="pi pi-arrow-right"
                        iconPos="right"
                        severity="success"
                        disabled={gatewayConditions.length === 0}
                        onClick={onNext}
                    />
                ) : state.triggerType === "TIME" && timePhase === "TIME" ? (
                    <Button
                        label="Next"
                        icon="pi pi-arrow-right"
                        iconPos="right"
                        severity="success"
                        disabled={!state.triggerTime}
                        onClick={() => setTimePhase("SWITCH")}
                    />
                ) : <div />}
            </div>

            <Dialog
                header="What does adding a time do?"
                visible={timeDescriptionVisible}
                style={{ width: "34vw" }}
                onHide={() => setTimeDescriptionVisible(false)}
            >
                <p style={{ margin: 0, fontSize: "14px", color: "#3d3d3d", lineHeight: 1.6 }}>
                    Adding a time doesn't replace the switch condition, it adds an extra check on top of it.
                    At the time (and days) you choose, the rule checks whether the switch is still in the state
                    you've set, and only runs its actions if it is.
                </p>
                <p style={{ margin: "12px 0 0 0", fontSize: "14px", color: "#3d3d3d", lineHeight: 1.6 }}>
                    For example: Monday – Friday at 18:00, if CCTV is still disarmed → send alert/take snapshot/switch output state (these actions are chosen in a later step).
                </p>
                <br />
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <Button label="Got it" severity="success" onClick={() => setTimeDescriptionVisible(false)} />
                </div>
            </Dialog>

            <Dialog
                header="What is a gateway event?"
                visible={gatewayDescriptionVisible}
                style={{ width: "34vw" }}
                onHide={() => setGatewayDescriptionVisible(false)}
            >
                <p style={{ margin: 0, fontSize: "14px", color: "#3d3d3d", lineHeight: 1.6 }}>
                    A gateway event is raised by the gateway itself, e.g. when a padlock is unlocked, opened,
                    closed, or an invalid pin is attempted. This is different to a switch changing state, and
                    doesn't require selecting an output or input pin.
                </p>
                <br />
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <Button label="Got it" severity="success" onClick={() => setGatewayDescriptionVisible(false)} />
                </div>
            </Dialog>
        </>
    );
};

export default WizardStepTrigger;
